<template>
  <md-dialog :md-click-outside-to-close="true" :md-active.sync="showDialog">
    <div class="s1-loc__progress-spinner-wrapper" v-show="loading">
      <md-progress-spinner class="md-accent" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <md-dialog-title>
      <div class="s1-U__full-width">
        <h3 class="md-display-1 s1-U__text-color--primary">{{ $t('change_password') }}</h3>
      </div>
    </md-dialog-title>
    <md-dialog-content style="max-width: 368px">
      <s1vm-sone-error :errorModel="error"></s1vm-sone-error>
      <p class="md-caption s1-U__mg--bt32">{{ $t('password_validation') }}</p>
      <md-field :md-counter="false" class="md-field-helper-text s1-U__width--320px" :class="{'md-invalid s1-U__mg--bt48' : $v.security.CurrentPassword.$error}">
        <label>{{ $t('current_password') }}</label>
        <md-input
          type="password"
          id="CurrentPassword"
          name="CurrentPassword"
          v-model="security.CurrentPassword"
          maxlength="30"
        ></md-input>
        <span class="md-error" v-if="$v.security.CurrentPassword.$error">{{ $t('field.invalid') }}</span>
      </md-field>

      <md-field
        :md-counter="false"
        class="md-field-helper-text s1-U__width--320px"
        :class="{'md-invalid s1-U__mg--bt48' : $v.security.NewPassword.$error}"
      >
        <label>{{ $t('new_password') }}</label>
        <md-input
          type="password"
          id="NewPassword"
          name="NewPassword"
          v-model="security.NewPassword"
          maxlength="30"
        ></md-input>
        <span class="md-error" v-if="$v.security.NewPassword.$error">{{ $t('field.invalid') }}</span>
      </md-field>

      <md-field
        :md-counter="false"
        class="md-field-helper-text s1-U__width--320px"
        :class="{'md-invalid s1-U__mg--bt48' : $v.security.ConfirmNewPassword.$error}"
      >
        <label>{{ $t('confirm_new_password') }}</label>
        <md-input
          type="password"
          id="ConfirmNewPassword"
          name="ConfirmNewPassword"
          v-model="security.ConfirmNewPassword"
          maxlength="30"
        ></md-input>
        <span class="md-error" v-if="$v.security.ConfirmNewPassword.$error">{{ $t('field.invalid') }}</span>
      </md-field>
    </md-dialog-content>

    <md-dialog-actions class="s1-U__pd16">
      <md-button type="button" class="md-raised" @click="close(false)">{{ $t('cancel') }}</md-button>
      <md-button
        type="button"
        class="md-primary md-raised"
        @click="save"
      >{{ $t('btn.save_new_password') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import UserPasswordChange from '@sone/sone-frontend-core/src/models/UserPasswordChange';
import { validationMixin } from 'vuelidate';
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  mixins: [validationMixin],
  props: {
    id: String,
  },
  validations: {
    security: {
      CurrentPassword: {
        required,
        maxLength: maxLength(30),
        minLength: minLength(8),
      },
      NewPassword: {
        required,
        maxLength: maxLength(30),
        minLength: minLength(8),
      },
      ConfirmNewPassword: {
        required,
        maxLength: maxLength(30),
        minLength: minLength(8),
        sameAs: sameAs('NewPassword'),
      },
    },
  },
  data: () => ({
    error: null,
    security: new UserPasswordChange(),
    loading: false,
    showDialog: false
  }),
  methods: {
    ...mapActions('user', {
      changePassword: 'CHANGE_PASSWORD'
    }),
    save() {
      this.$v.$touch();
      this.error = null;
      if (!this.$v.$invalid) {
        this.loading = true;
        this.changePassword({ id: this.id, data: this.security }).then(() => {
          this.close(true);
        }).catch((err) => {
          this.error = err;
          this.loading = false;
        });
      }
    },
    open() {
      this.loading = false;
      this.error = null;
      this.$v.$reset();
      this.security = new UserPasswordChange();
      this.showDialog = true;
    },
    close(changed) {
      this.showDialog = false;
      this.loading = false;
      this.$emit('close', changed);
    }
  }
}
</script>
